import { postRequestMall } from './request/request'
import { GoodsItemStatusTypes, IGoodsList, GoodsOrderItemType, GoodsOrderItemResponse } from "./types/goodsTypes";
import { judgeClient } from '@/utils/utils'
import { GameRoleItemType, IAddCartGoodsParams, ICheckCartResp } from '@/@types/types'
import { UseGetCurrentGameConfigHooks } from '@/hooks/useGetCurrentGameConfigHooks'

export interface OrderPlaceData {
  order?: string
  url?: string
  sessionId?: string
  publicKey?: string
  sandBox?: boolean | number | string
  uiMode?: 'elements' | 'hostedPage'
  amount?: number
  currency?: string
  sliderVerify?: boolean
}

type OrderPlaceResponse = OrderPlaceData & {
  sliderVerify?: boolean
}

// 直购参数在拉起收银台后会从 URL 清除，下单时从缓存读取并组装 slf。
const getDirectBuyOrderParams = () => {
  const batchNum = sessionStorage.getItem('hero_batch_num')
  if (!batchNum) return {}

  const dLinkNum = sessionStorage.getItem('hero_d_link_num')
  return {
    slf: JSON.stringify({
      batchNum,
      ...(dLinkNum ? { dLinkNum } : {})
    })
  }
}

// 所有商品列表
export const apiGoodsListAll = (params?: any) =>
  postRequestMall<IGoodsList>('/sku/listNew', {
    ...params,
    cancelAxios: true
  })

// 预检商品
export const apiGoodsCheckCpSkus = (params?: any) =>
  postRequestMall<{ [K: string]: GoodsItemStatusTypes }>('/sku/checkCpSkus', params)

// 购物车下单
export const apiOrderCartPlace = (params?: any) => {
  const { currentGameConfig } = UseGetCurrentGameConfigHooks()
  const XXYZ_RETURN_URL = 'https://xxyzshopbuy.zealshow.com/#/'
  const returnUrl = currentGameConfig.path === '/xxyz'
    ? XXYZ_RETURN_URL
    : process.env.VUE_APP_DOMAIN_URL + currentGameConfig.path
  return postRequestMall<OrderPlaceResponse>('/order/placeCar', {
    plat: judgeClient(),
    ...getDirectBuyOrderParams(),
    ...params,
    returnUrl
  })
}

// 购物车下单 IOS
export const apiIOSOrderPlace = (params: any, path?: string) => {
  return postRequestMall<string>('/order/placeCar', {
    plat: judgeClient(),
    ...getDirectBuyOrderParams(),
    ...params,
    returnUrl: `${process.env.VUE_APP_DOMAIN_URL}${path || ''}`
  })
}

// 订阅商品
export const apiSubGoodsPlace = (params?: any) =>
  postRequestMall<string>('/order/placeSubscribe', {
    ...getDirectBuyOrderParams(),
    ...params
  }, false, true)

// 获取是否授权
export const apiGetAuth = (params?: any) =>
  postRequestMall('/game/role/roleMandateStatus', params, false, true)

// 授权订阅
export const apiAuthSub = (params?: any) => postRequestMall('/order/mandate', params, false, true)

// （免登录）确认角色信息
export const apiGameRoleConfirmRole = (params?: any) =>
  postRequestMall<GameRoleItemType>('/game/role/confirmRole', params, false, false)

// 获取手机验证码
export const apiGameGetPhoneCode = (params: any) =>
  postRequestMall('/third/login/getPhoneCode', params, false, true)

// 手机验证码登录
export const apiGameGetPhoneLogin = (params: any) =>
  postRequestMall<any>('/third/login/phoneLogin', params, false, false)

// （免登录）通过orderToken得到订单列表
export const apiOrderListOrderToken = (params?: any) =>
  postRequestMall<GoodsOrderItemResponse>('/order/listOrderToken', params)

// 获取订单状态
export const apiGetOrderStatus = (params?: any) =>
  postRequestMall('/order/checkOrderStatus', params, false, false)

// 取消订阅
export const apiCancelSub = (params?: any) =>
  postRequestMall('/order/cancelSub', params, false, true)

// 使用兑换码
export const apiUseRedeem = (params?: any) =>
  postRequestMall('/redeem/useRedeem', params, false, false)

// 获取私域链接（国内）
export const apiOrderAttentionLink = (params?: any) =>
  postRequestMall<any>('/order/attentionLink', params, false, false)

// 获取赠送活动（限时返利）
export const apiGetAwardList = (params?: any) =>
  postRequestMall<any>('/game/awardList', params, false, false)

// 添加购物车接口
export const apiAddCartGoods = (params: IAddCartGoodsParams) =>
  postRequestMall<ICheckCartResp>(
    '/order/checkCar',
    {
      ...params,
      cancelAxios: true
    },
    false,
    false
  )

// 添加购物车接口V2
export const apiAddCartGoodsV2 = (params: IAddCartGoodsParams) =>
  postRequestMall<ICheckCartResp>(
    '/order/checkCarV2',
    {
      ...params,
      cancelAxios: true
    },
    false,
    false
  )
